<template>
  <div>
    <DxSelectBox
      :search-enabled="true"
      :data-source="gridDataSource"
      :search-mode="searchModeOption"
      :search-expr="searchExprOption"
      :search-timeout="searchTimeoutOption"
      :min-search-length="minSearchLengthOption"
      :show-data-before-search="showDataBeforeSearchOption"
      :accept-custom-value="true"
      display-expr="name"
      value-expr="id"
      :value="gridBoxValue"
      :disabled="disabled"
      ref="rltfld"
      @value-changed="onValueChanged"
    />
  </div>
</template>

<script>
import { DxSelectBox } from "devextreme-vue/select-box";
import CustomStore from "devextreme/data/custom_store";

export default {
  props: {
    rRoute: String,
    slug: String,
    modelValue: String,
    disabled: Boolean,
    dependentOnId: String,
    dependentOn: Array,
    depedentModule: Array,
    dependentRoute: String,
    dependentModuleRoute: String,
  },
  components: {
    DxSelectBox,
  },
  data() {
    return {
      gridDataSource: null,
      gridBoxValue: "",
      searchModeOption: "contains",
      searchExprOption: "name",
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,

      showDataBeforeSearchOption: true,
    };
  },
  methods: {
    makeAsyncDataSource(rRoute, slug, params) {
      console.log("DEPEND RELATE COMPONENT world", rRoute, slug);

      return new CustomStore({
        key: "id",
        loadMode: "processed",
        load: function (loadOptions) {
          let listurl = "/" + slug + "/" + rRoute + "/relatedata";

          //  let listurl = "/" + slug + "/" + rRoute + "/field/rlt_fld_build_relate";

          console.log("RELATE COMPONENT list url", listurl);

          var parameters = {};

          var tFilter = [
            loadOptions.searchExpr,
            loadOptions.searchOperation,
            loadOptions.searchValue,
          ];

          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          if (
            loadOptions.searchExpr != null &&
            loadOptions.searchValue != null
          ) {
            parameters.filter = JSON.stringify(tFilter);
          }
          let merged = { ...parameters, ...params };
          var config = {
            params: merged,
          };

          return axios
            .get(listurl, config)
            .then((response) => {
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        byKey: function (key) {
          if (key != null || key !== "undefined") {
            let url = "/" + slug + "/" + rRoute + "/getById/" + key;
            return axios
              .get(url)
              .then((response) => {
                return {
                  id: response.data.data.id,
                  name: response.data.data.name,
                };
              })
              .catch(() => {
                throw "Data Loading Error";
              });
          }
        },
      });
    },
    onValueChanged(e) {
      // console.log("Dependent OnValue Change",e.value);
      //  this.$emit("update:modelValue", e.value);

      // Check if e.value is an object and has an id property
      if (typeof e.value === "object" && e.value !== null && "id" in e.value) {
        // It's an object and has an id, so emit the id
        this.$emit("update:modelValue", e.value.id);
      } else {
        // It's not an object or doesn't have an id, so emit the value directly
        this.$emit("update:modelValue", e.value);
      }
    },
    getDependentValue(itemId) {
      let url =
        "/" +
        this.slug +
        "/" +
        this.dependentModuleRoute +
        "/getById/" +
        itemId;
      return axios
        .get(url)
        .then((response) => {
          // Return the resolved data
          this.gridBoxValue = {
            id: response.data.data.id,
            name: response.data.data.name,
          };
          //this.gridBoxValue = resp.id
          // this.gridBoxValue  = response.data.data.name;
          // return response.data.data.name;
        })
        .catch((error) => {
          console.error("Error fetching dependent value:", error);
          // Optionally, you can throw the error to propagate it to the caller
          throw error;
        });
    },
  },
  mounted() {
    //console.log("depedentModule Name",this.depedentModule.name)
    console.log("Depedent Component modelValue", this.modelValue);

    this.$watch("dependentOnId", (nval, oval) => {
      // console.log("Dependent Component nval", nval);
      // console.log("Dependent Component oval", oval);

      this.gridDataSource = this.makeAsyncDataSource(
        this.dependentRoute,
        this.slug,
        { id: nval, relateName: this.depedentModule.name }
      );
    });

    if (this.modelValue) {
      this.gridDataSource = this.makeAsyncDataSource(
        this.dependentRoute,
        this.slug,
        { id: this.dependentOnId, relateName: this.depedentModule.name }
      );
      //this.gridBoxValue=this.gridDataSource;
      console.log("Depedent modelValue ID ", this.modelValue);
      this.getDependentValue(this.modelValue);
    }

    //this.gridBoxValue=this.modelValue;
  },
};
</script>

<style>
</style>